import styles from "./styles.module.css";
import { useState, useEffect, useContext } from "react";
import SelectAction from "../../../actions/selectaction";
import EditAction from "../../../actions/editaction";
import EditOpperation from "../../../actions/editopperation";
import AddAction from "../../canvas/workflows/addaction";
import ActionCard from "../../canvas/workflows/actioncard";
import Opperation from "../../canvas/workflows/opperataion";
import _actions, { _types } from "../../../utils/actions";
import { HiOutlineArrowNarrowDown } from "react-icons/hi";
import { useDrop } from "react-dnd";

export default function Actions({ setHook, webhook, zoom, offset }) {
  const [selected, setSelected] = useState(null);
  const [opperation, setOpperation] = useState(null);
  const [_open, setOpen] = useState(false);
  const [returnSources, setReturnSources] = useState([]);

  const [{ hovered }, dropRef] = useDrop({
    accept: "action",
    drop: (item) => handleDrop(item.action, -1),
    collect: (monitor) => ({
      hovered: !!monitor.isOver({ shallow: true }) && monitor.canDrop(),
    }),
  });

  const handleUpdate = () => {};

  const handleSelect = (action) => {
    const actions = [...webhook.actions];
    actions.push(action);
    setHook({ ...webhook, actions });
  };
  const handleDelete = (index) => {
    const actions = [...webhook.actions];
    actions.splice(index, 1);
    setHook({ ...webhook, actions });
  };
  const handleCardDrop = (action) => {
    const actions = [...webhook.actions];
    const findIndex = actions.findIndex((x) => x.id === action.id);
    console.log("carddrop", actions);
    actions.splice(findIndex, 1);
    setHook({ ...webhook, actions });
  };
  const handleDrop = (action, index) => {
    console.log(action, index);
    const actions = [...webhook.actions];
    actions.splice(index + 1, 0, action);
    console.log("drop", actions);
    setHook({ ...webhook, actions });
  };

  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        transform: `scale(${zoom}) translate(${-offset.x}px, ${-offset.y}px)`,
        transformOrigin: "center",
      }}
    >
      <div
        style={{
          borderRadius: 3,
          width: "fit-content",
          boxSizing: "border-box",
          flexDirection: "column",
          alignItems: "center",
          overflow: "visible",
          display: "flex",
          margin: 15,
        }}
      >
        <div ref={dropRef} style={{ width: 300 }}>
          <div
            style={{
              padding: 15,
              backgroundColor: "white",
              borderRadius: 8,
            }}
          >
            Webhook is Triggered
          </div>
          <div
            style={{
              color: "#333",
              fontSize: 24,
              marginTop: 8,
              width: "fit-content",
              marginLeft: "auto",
              marginRight: "auto",
              marginBottom: hovered ? 48 : 0,
            }}
          >
            <HiOutlineArrowNarrowDown />
          </div>
        </div>
        {webhook.actions.map((a, i) => {
          if (a.children) {
            return (
              <Opperation
                onChange={handleUpdate}
                key={a.id}
                sources={[]}
                opperation={a}
                onDelete={() => handleDelete(i)}
                onDragDrop={handleCardDrop}
                onDrop={handleDrop}
                onClick={() => setOpperation(a)}
                index={i}
                actions={_actions}
                types={_types}
              />
            );
          }
          return (
            <ActionCard
              key={a.id}
              onDragDrop={handleCardDrop}
              onDrop={handleDrop}
              action={a}
              index={i}
              onClick={() => setSelected(a)}
              onDelete={() => handleDelete(i)}
            />
          );
        })}
        <AddAction onClick={() => setOpen(true)} />
      </div>

      <EditAction
        action={selected}
        onSave={handleUpdate}
        actions={_actions}
        onClose={() => setSelected(false)}
        sources={[...returnSources]}
      />
      <SelectAction
        open={_open}
        onClose={() => setOpen(false)}
        onSelect={handleSelect}
        actions={_actions}
        types={_types}
      />
      <EditOpperation
        actions={_actions}
        sources={[...returnSources]}
        opperation={opperation}
        onClose={() => setOpperation(null)}
        onSave={handleUpdate}
      />
    </div>
  );
}
